<template>
    <div class="form-field" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-readonly': readOnly}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper" style="background-size:auto 60%;background-repeat:no-repeat;background-position:right 10px center;" v-bind:style="{backgroundImage:'url('+img+')'}">
                <div><input type="text" value="" v-model="internalValue" :placeholder="placeholder" :readonly="readOnly" :maxlength="maxlength"/></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','suffix','lang','required','readonly','maxlength'],
        data: function () {
            return {
                internalValue: '',
                langClass:"",
                img: null
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.img = window.apiUrl + /ean/ + newVal
                console.log("img", this.img)
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Barcode.vue